import { motion } from 'framer-motion';

export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Trusted & Reliable',
      description: 'Over 10 years of experience delivering safe, memorable travel experiences with 24/7 support',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Best Value Guaranteed',
      description: 'Competitive pricing with no hidden fees. We match or beat competitor prices on similar packages',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Personalized Service',
      description: 'Every trip is tailored to your preferences. Our travel experts craft unique itineraries just for you',
    },
    {
      icon: 'ri-global-line',
      title: 'Worldwide Destinations',
      description: 'Access to 100+ destinations across 6 continents with local guides and authentic experiences',
    },
  ];

  return (
    <section className="py-24 bg-navy-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-2 h-2 rounded-full bg-accent-pink"></div>
              <span className="text-xs uppercase tracking-wider text-accent-pink font-semibold">
                Why Candy World Tours
              </span>
            </div>
            
            <h2 className="text-5xl font-bold mb-12 leading-tight">
              Travel with<br />Confidence
            </h2>

            <div className="space-y-10">
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex items-start gap-6"
                >
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary-600 to-accent-pink flex items-center justify-center flex-shrink-0">
                    <i className={`${benefit.icon} text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{benefit.title}</h3>
                    <p className="text-gray-400 leading-relaxed max-w-md">
                      {benefit.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/73fd2f0cf18094add1b74812171f9a1a.jpg"
                alt="Happy Travelers"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-accent-pink/20 to-transparent"></div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-white text-navy-900 rounded-2xl p-6 shadow-2xl">
              <p className="text-4xl font-bold bg-gradient-to-r from-primary-600 to-accent-pink bg-clip-text text-transparent">
                10+
              </p>
              <p className="text-sm font-semibold">Years Experience</p>
            </div>
            
            <div className="absolute -top-6 -right-6 bg-white text-navy-900 rounded-2xl p-6 shadow-2xl">
              <p className="text-4xl font-bold bg-gradient-to-r from-primary-600 to-accent-pink bg-clip-text text-transparent">
                98%
              </p>
              <p className="text-sm font-semibold">Satisfaction Rate</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}